import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import styles from "./Maintainance.module.css";

import warning_icon from "../../../assets/images/icons/warning_icon.png";

import { useNavigate } from "react-router-dom";
const Maintainance = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className={styles.main}>
        <img src={warning_icon} alt="icon" className={styles.warning_icon} />
        <div className={styles.hr} />
        <div className={styles.text_main}>
          <div>メンテナンス中</div>
          <div>ご不便をお掛けしております。</div>
          <div>不具合を解消次第アップロードします。</div>
        </div>

        <div className={styles.hr} />
        <div className={styles.button_section}>
          <div
            onClick={() => {
              navigate("/top");
            }}
            className={styles.btn1}
          >
            Top
          </div>
          <div
            onClick={() => {
              navigate(-1);
            }}
            className={styles.btn2}
          >
            戻る
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Maintainance;
